import usePersistentContext from "../../hooks/usePersistentContext"
import { DEFAULT_MODEL_PERSISTENT_KEY } from "./types"
import type { ModelId } from "./types"

/** Reads and writes the user's persisted default model preference. */
export const usePersistedChatModel = (): readonly [
  ModelId | null | undefined,
  (value: ModelId | null) => Promise<ModelId | null>,
] => {
  const [persisted, setDefaultModel] = usePersistentContext<ModelId | null>(
    DEFAULT_MODEL_PERSISTENT_KEY
  )
  return [persisted, setDefaultModel] as const
}
